import styled from 'styled-components'

export const SpeciesDetailsSearchFormWrapper = styled.div`
  width: 100%;  
`


export const SpeciesPaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0 32px 0;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
`

export const SpeciesSearchContainer = styled.div`
  height: 48px;
  width: 100%;  
  border-radius: 4px;
  padding: 4px 2px;
  background: rgba(20, 20, 20, 0.1);
  margin-bottom: 68px;
  cursor: ${(p) => {
    return p.disabled ? 'not-allowed' : 'pointer'
  }};
`
